/**
 * Phase 3.50 — Erweiterte Marken- und Modell-Listen für die Inserate-Erfassung.
 * Free-text bleibt erlaubt; die Listen dienen als Vorschlag-Datalist.
 */

export const MOTO_BRANDS = [
    "AGM", "Aprilia", "Benelli", "Beta", "Bimota", "BMW", "Brixton", "Buell",
    "Cagiva", "CFMoto", "Daelim", "Ducati", "e-Schwalbe", "Emco", "Energica",
    "Explorer", "Fantic", "GasGas", "Generic", "Govecs", "Hanway", "Harley-Davidson",
    "Honda", "Horwin", "Husaberg", "Husqvarna", "Indian", "Italjet", "Jawa",
    "Kawasaki", "Keeway", "KTM", "Kumpan", "Kymco", "Lambretta", "Laverda",
    "Lexmoto", "Lifan", "LiveWire", "Luxxon", "Macbor", "Mash", "MBK", "Mondial",
    "Moto Guzzi", "Moto Morini", "MV Agusta", "NIU", "Norton", "Nova Motors", "NSU",
    "Orcal", "Peugeot Motocycles", "Piaggio", "Polaris", "Puch", "QJMotor", "Quadro",
    "Rieju", "Royal Enfield", "Sachs", "SEAT MÓ", "Sherco", "Silence", "Simson",
    "Sinnis", "Sunra", "Super Soco", "Sur-Ron", "Suzuki", "SWM", "SYM", "Talaria",
    "Triumph", "Trinity", "TVS", "Unu", "Ural", "Vespa", "Victory", "Vmoto", "Voge",
    "WMI", "Yamaha", "Zero Motorcycles", "Zontes",
];

export const BIKE_BRANDS = [
    "Bergamont", "Bianchi", "BMC", "Bulls", "Canyon", "Cannondale", "Centurion",
    "Conway", "Cube", "Diamant", "Felt", "Focus", "Gazelle", "Ghost", "Giant",
    "Haibike", "Kalkhoff", "Kona", "KTM Fahrrad", "Look", "Merida", "Orbea",
    "Pegasus", "Pinarello", "Radon", "Riese & Müller", "Rose", "Santa Cruz",
    "Scott", "Specialized", "Stevens", "Storck", "Tern", "Trek", "Trinx",
    "Velo de Ville", "Winora",
];

export const BIKE_TYPES = [
    "Citybike", "Crossbike", "Cyclocross", "Dirtbike", "E-Bike City",
    "E-Bike MTB", "E-Bike Rennrad", "E-Bike Trekking", "Fatbike", "Faltrad",
    "Fitnessrad", "Gravel", "Hollandrad", "Kinderrad", "Lastenrad", "Mountainbike",
    "Pedelec", "Rennrad", "S-Pedelec", "Tandem", "Trekkingrad", "Triathlonrad",
];

export const FUEL_OPTIONS = ["Benzin", "Elektro"];

export const DRIVE_TYPES = ["Riemen", "Kette", "Kardan", "Radnabe"];

/** Phase 3.51 — Schadstoffklasse (Euro-Norm) */
export const EMISSION_CLASSES = ["Euro 2", "Euro 3", "Euro 4", "Euro 5", "Euro 5+", "Euro 6"];

/** Phase 3.52 — Farbbasis (Grobklassifizierung für Filter & Suche) */
export const COLOR_BASES = [
    "Rot", "Blau (hell)", "Blau (dunkel)", "Grau (hell)", "Grau (dunkel)",
    "Grün", "Bunt", "Zweifarbig", "Gelb", "Schwarz", "Weiß", "Orange",
];

/** Phase 3.52 — Wochentage für Sharing-Verfügbarkeit */
export const WEEKDAYS = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];

/** Phase 3.52 — Land der Zulassung */
export const COUNTRIES = [
    { code: "DE", label: "Deutschland" },
    { code: "AT", label: "Österreich" },
    { code: "CH", label: "Schweiz" },
    { code: "NL", label: "Niederlande" },
    { code: "IT", label: "Italien" },
    { code: "FR", label: "Frankreich" },
    { code: "BE", label: "Belgien" },
    { code: "LU", label: "Luxemburg" },
    { code: "DK", label: "Dänemark" },
    { code: "PL", label: "Polen" },
    { code: "CZ", label: "Tschechien" },
    { code: "ES", label: "Spanien" },
    { code: "EU", label: "EU-Sonstige" },
];

/** Phase 3.60 — Getriebe-Optionen (Motorrad) */
export const TRANSMISSION_OPTIONS = [
    "Schaltgetriebe",
    "Halbautomatik",
    "Automatik",
    "CVT (Stufenloses Getriebe)",
];

/** Phase 3.51 — Erweiterte Zustands-Optionen (statt nur Neu/Gebraucht) */
export const CONDITION_OPTIONS = [
    "Neufahrzeug",
    "Tageszulassung",
    "Vorführfahrzeug",
    "Gebrauchtfahrzeug",
    "Jungtimer",
    "Oldtimer",
    "Unrepariertes Fahrzeug",
    "Schrott / Verwertung / Export",
];

/** Phase 3.57 — Zylinder-Anzahl Dropdown */
export const CYLINDER_OPTIONS = [1, 2, 3, 4, 6];

/** Phase 3.57 — Umweltplakette */
export const UMWELTPLAKETTEN = [
    { value: "nicht_bekannt", label: "Nicht bekannt" },
    { value: "keine", label: "Keine" },
    { value: "rot", label: "Rot" },
    { value: "gruen", label: "Grün" },
    { value: "blau", label: "Blau" },
];

/** Phase 3.57 — Ausstattungs-Checkboxen (Motorrad) — erweitert Phase 3.70 */
export const FEATURE_OPTIONS = [
    "ABS",
    "Abstandswarner",
    "Alarmanlage",
    "ASR",
    "Berganfahrassistent",
    "Bi-Xenon Scheinwerfer",
    "Blipper",
    "Elektrostarter",
    "Griffheizung",
    "Katalysator",
    "Keyless",
    "Kickstarter",
    "Kurven-ABS",
    "Laserlicht",
    "LED Scheinwerfer",
    "LED Tagfahrlicht",
    "Navigationssystem",
    "Schaltautomat",
    "Scheibe",
    "Semi-aktives Fahrwerk",
    "Stoppie-Control",
    "Totwinkel-Assistent",
    "USB",
    "Wegfahrsperre",
    "Wheelie-Control",
    "Xenonscheinwerfer",
];

/** Phase 3.70 — Motorrad-Fahrzeugtypen */
export const MOTORCYCLE_VEHICLE_TYPES = [
    "Chopper/Cruiser",
    "Dirt Bike",
    "Enduro/Reiseenduro",
    "Gespann/Seitenwagen",
    "Klein/Leichtkraftrad",
    "Mofa/Mokick/Moped",
    "Motorrad",
    "Naked Bike",
    "Pocket Bike",
    "Quad",
    "Rallye/Cross",
    "Rennsport",
    "Roadster",
    "Roller/Scooter",
    "Sportler/Supersportler",
    "Sporttourer",
    "Streetfighter",
    "Super Moto",
    "Tourer",
    "Trike",
    "Anderer Fahrzeugtyp",
];

/** Phase 3.57 — Zubehör-Checkboxen */
export const ACCESSORY_OPTIONS = [
    "Topcase",
    "Koffer",
    "Sturzbügel",
    "Scheibe",
];

/** Phase 3.57 — Garantie-Auswahl */
export const WARRANTY_TYPES = [
    { value: "hersteller", label: "Hersteller-Garantie" },
    { value: "drittanbieter", label: "Drittanbieter-Garantie" },
    { value: "gesetzlich", label: "Gesetzliche Gewährleistung" },
];

/** Phase 3.51 — Bild-Beschriftungen (Drop-Down pro Bild) */
export const IMAGE_LABELS = [
    "Linke Seite",
    "Rechte Seite",
    "Vorne",
    "Hinten",
    "Cockpit mit Tachostand",
    "Hinten oben",
    "Vorne oben",
    "Hinterer Bereich seitlich mit Auspuff",
    "Hinterer Bereich mit Motor",
    "Stauraum",
    "Sonstiges Zubehör",
    "Schlüsselsatz",
    "Diverses",
];

/** Curated brand → models map (Vorschlag-Datalist; Free-Text bleibt erlaubt). */
export const BRAND_MODELS = {
    "BMW": ["R 1250 GS", "R 1300 GS", "S 1000 RR", "S 1000 R", "F 900 R", "F 900 XR",
        "G 310 R", "G 310 GS", "R 18", "R nineT", "K 1600 GT", "R 1250 RT", "C 400 X",
        "CE 04"],
    "Ducati": ["Panigale V4", "Panigale V2", "Streetfighter V4", "Monster", "Monster SP",
        "Multistrada V4", "Multistrada V2", "Diavel V4", "Scrambler 800", "Hypermotard 950",
        "DesertX"],
    "Honda": ["Africa Twin", "CB650R", "CBR650R", "Hornet 750", "Hornet 1000", "CBR1000RR-R",
        "CMX1100 Rebel", "Forza 750", "Forza 350", "PCX125", "Transalp 750", "NC750X",
        "Gold Wing", "Monkey"],
    "Kawasaki": ["Z900", "Z650", "Z H2", "Ninja H2", "Ninja ZX-10R", "Ninja 650",
        "Versys 650", "Versys 1000", "Vulcan S", "KX450", "W800"],
    "Yamaha": ["MT-07", "MT-09", "MT-10", "Tracer 7", "Tracer 9", "Ténéré 700", "YZF-R1",
        "YZF-R7", "TMAX", "XMAX 300", "Bolt R-Spec", "XSR700", "XSR900"],
    "KTM": ["390 Duke", "790 Duke", "890 Duke", "1290 Super Duke R", "RC 390", "RC 8C",
        "890 Adventure", "1290 Super Adventure", "350 EXC-F", "300 EXC", "450 SX-F"],
    "Triumph": ["Street Triple", "Speed Triple", "Trident 660", "Tiger 900", "Tiger 1200",
        "Bonneville T120", "Speedmaster", "Rocket 3"],
    "Harley-Davidson": ["Sportster S", "Nightster", "Street Bob", "Fat Bob", "Fat Boy",
        "Heritage Classic", "Road Glide", "Street Glide", "Pan America"],
    "Suzuki": ["GSX-R1000", "GSX-S1000", "GSX-S950", "GSX-8S", "Hayabusa", "V-Strom 800DE",
        "V-Strom 1050", "Burgman 400", "SV650"],
    "Aprilia": ["RSV4", "Tuono V4", "RS 660", "Tuono 660", "Tuareg 660", "SR GT 200"],
    "MV Agusta": ["F3 800", "Brutale 1000", "Dragster", "Turismo Veloce"],
    "Vespa": ["Primavera 125", "Sprint 125", "GTS 300", "Elettrica", "Sei Giorni"],
    "Moto Guzzi": ["V7 Stone", "V9 Bobber", "V85 TT", "V100 Mandello", "Stelvio"],
    "Royal Enfield": ["Classic 350", "Meteor 350", "Hunter 350", "Himalayan 450", "Interceptor 650"],
    "Husqvarna": ["Vitpilen 401", "Svartpilen 401", "Norden 901", "FE 350", "FX 450", "TE 250"],
    "Indian": ["Scout", "FTR", "Chief", "Springfield", "Roadmaster"],
    "Zero Motorcycles": ["SR/F", "SR/S", "DSR/X", "FX", "FXE"],
    "Energica": ["Eva Ribelle", "Ego", "Experia"],
    "Piaggio": ["Liberty 125", "Beverly 400", "Medley 125", "MP3 530", "1"],
    "Kymco": ["Agility 125", "Like 125", "AK 550", "Xciting S 400", "Super 8"],
    "SYM": ["Symphony 125", "Joymax Z 300", "Maxsym 600", "Cruisym 300"],
    // E-Roller / E-Moped / E-Leichtkraftrad (Phase: Marken-Erweiterung Feb 2026)
    "NIU": ["NQi GT", "NQi GTS", "MQi GT", "MQi+ Sport", "UQi GT", "NQiX", "FQiX"],
    "e-Schwalbe": ["e-Schwalbe (L1e)", "e-Schwalbe (L3e)"],
    "Govecs": ["GO! S2.4", "GO! S3.4", "Schwalbe", "Elmoto"],
    "Emco": ["Novum", "Novax", "C3000", "C4000", "RT3000"],
    "Super Soco": ["TC", "TC Max", "CPx", "TS", "TSx", "VS1"],
    "Silence": ["S01", "S02", "S04"],
    "Horwin": ["EK1", "EK3", "SK1", "SK3", "CR6", "SENMENTI O"],
    "Sur-Ron": ["Light Bee X", "Light Bee L1e", "Storm Bee", "Ultra Bee"],
    "Talaria": ["Sting R MX4", "Sting MX3", "XXX", "Dragon"],
    "Kumpan": ["1954 Ri", "54 ignite", "54 inspire", "54 impulse"],
    "Unu": ["Unu Scooter (2.0)", "Unu Classic"],
    "Lambretta": ["V125 Special", "V200 Special", "G350", "Elettra"],
    "Italjet": ["Dragster 125", "Dragster 200", "Dragster 559"],
    "LiveWire": ["S2 Del Mar", "One", "S2 Mulholland"],
    "Simson": ["S51", "S50", "Schwalbe KR51", "SR50", "S53"],
    "Sachs": ["MadAss", "ZX 125", "Bee", "Speedjet"],
    // Bicycle brands
    "Specialized": ["Tarmac SL7", "Tarmac SL8", "Roubaix", "Diverge", "Stumpjumper",
        "Enduro", "Levo SL", "Levo", "Vado", "Allez"],
    "Canyon": ["Aeroad", "Ultimate", "Endurace", "Grail", "Spectral", "Strive",
        "Pathlite:ON", "Roadlite:ON", "Spectral:ON"],
    "Trek": ["Madone", "Émonda", "Domane", "Checkpoint", "Top Fuel", "Fuel EX", "Slash",
        "Allant+", "Verve+", "Marlin"],
    "Cube": ["Attain", "Agree", "Litening", "Reaction", "Stereo Hybrid", "Touring Hybrid",
        "Acid", "Aim"],
    "Giant": ["TCR Advanced", "Defy Advanced", "Propel Advanced", "Trance X", "Reign",
        "Stance E+", "Trance X E+"],
    "Haibike": ["AllMtn", "AllTrail", "Trekking", "FullSeven", "FullNine", "HardSeven"],
    "Riese & Müller": ["Charger4", "Roadster", "Delite5", "Supercharger2", "Load 60"],
    "Cannondale": ["SuperSix Evo", "Synapse", "Topstone", "Scalpel", "Habit", "Moterra"],
    "Scott": ["Addict RC", "Foil RC", "Spark RC", "Genius", "Patron eRIDE", "Strike eRIDE"],
    "Bianchi": ["Specialissima", "Oltre", "Infinito", "Methanol", "E-Omnia"],
    "Focus": ["IZALCO", "PARALANE", "JAM²", "THRON²", "ATLAS²", "Sam²"],
    "Merida": ["Reacto", "Scultura", "Silex", "Big Nine", "One-Sixty", "eOne-Sixty"],
    "KTM Fahrrad": ["Macina Aera", "Macina Style", "Macina Sport", "Macina Cross", "Revelator Alto"],
    "Centurion": ["Crossline", "Backfire", "Numinis", "E-Fire"],
    "Conway": ["Cairon S", "Cairon T", "GRV", "Xyron", "MS"],
    "Stevens": ["Galant", "Strada", "Tonisteig", "E-Vermont", "E-Galant"],
    "Pegasus": ["Premio", "Solero", "Master", "Premium"],
};
